import React, { useState } from "react";
import styles from "../Navbar/Navbar.module.css";
import { MdClose } from "react-icons/md";
import { FiMenu } from "react-icons/fi";
import { Link, animateScroll as scroll } from "react-scroll";
import { useTranslation } from "react-i18next";

export default function Navbar()
{
  const { t, i18n } = useTranslation("global");
  const [navbarOpen, setNavbarOpen] = useState(false);
  const handleToggle = () =>
  {
    setNavbarOpen(!navbarOpen);
  };
  return (
    <>
      <nav className={styles.navBar}>
        <button className={styles.hamburger} onClick={handleToggle}>
          {navbarOpen ? (
            <MdClose
              style={{ color: "black", width: "20px", height: "20px" }}
            />
          ) : (
            <FiMenu style={{ color: "black", width: "20px", height: "20px" }} />
          )}
        </button>

        <div
          className={
            !navbarOpen ? styles.navigationMenu : styles.navigationMenuExpanded
          }
        >
          <ul className={navbarOpen ? styles.showMenu : ""}>
            <li>
              {/* // ver de recorrer array */}
              <Link
                onClick={() => setNavbarOpen(false)}
                to="home"
                spy={true}
                smooth={true}
                offset={-70}
                duration={500}
                activeClass={styles.active}
              >
                {t("nav.home")}
              </Link>{" "}
            </li>
            <li>
              {" "}
              <Link
                onClick={() => setNavbarOpen(false)}
                spy={true}
                smooth={true}
                offset={-70}
                duration={500}
                activeClass="active"
                to="about"
              >
                {t("nav.about")}
              </Link>
            </li>
            <li>
              {" "}
              <Link
                onClick={() => setNavbarOpen(false)}
                spy={true}
                smooth={true}
                offset={-70}
                duration={500}
                activeClass="active"
                to="projects"
              >
                {t("nav.projects")}
              </Link>
            </li>
            <li>
              {" "}
              <Link
                onClick={() => setNavbarOpen(false)}
                spy={true}
                smooth={true}
                offset={-70}
                duration={500}
                activeClass="active"
                to="contact"
              >
                {t("nav.contact")}
              </Link>
            </li>
          </ul>{" "}

        </div>

        <div className={styles.languages}>
          <button className={styles.flag} onClick={() => i18n.changeLanguage("es")}>
            <img
              height={40}
              width={40}
              src="https://cdn.countryflags.com/thumbs/spain/flag-round-250.png"
              alt="español"
            />
          </button>
          <button className={styles.flag} onClick={() => i18n.changeLanguage("en")}>
            <img
              height={40}
              width={40}
              src="https://upload.wikimedia.org/wikipedia/commons/thumb/8/88/United-states_flag_icon_round.svg/1024px-United-states_flag_icon_round.svg.png"
              alt="english"
            />
          </button>
        </div>
      </nav>
    </>
  );
}
